import { useMutationHook, useQueryHook } from "@/hooks"
import {
  readPdfTemplates,
  readPdfTemplateDetail,
  createPdfTemplate,
  updatePdfTemplate,
  deletePdfTemplate,
  updatePdfTemplateLastUsed,
} from "@/app/api/pdfTemplate"
import type {
  ReadPdfTemplatesParams,
  ReadPdfTemplatesResponse,
  ReadPdfTemplateDetailResponse,
} from "@/types/pdfTemplate"
import { UseQueryOptions } from "@tanstack/react-query"
import { ApiError } from "@/app/api/type"

export const usePdfTemplatesQuery = (params?: ReadPdfTemplatesParams, enabled = true) =>
  useQueryHook({
    queryKey: ["readPdfTemplates", ...(params ? Object.values(params) : [])],
    queryFn: () => readPdfTemplates(params),
    options: { enabled } as UseQueryOptions<ReadPdfTemplatesResponse, ApiError>,
  })

export const usePdfTemplateDetailQuery = (idfPdfTemplate: number, enabled = true) =>
  useQueryHook({
    queryKey: ["readPdfTemplateDetail", idfPdfTemplate],
    queryFn: () => readPdfTemplateDetail(idfPdfTemplate),
    options: { enabled: enabled && !!idfPdfTemplate } as UseQueryOptions<
      ReadPdfTemplateDetailResponse,
      ApiError
    >,
  })

export const useCreatePdfTemplateMutation = () =>
  useMutationHook(createPdfTemplate, [["readPdfTemplates"]])

export const useUpdatePdfTemplateMutation = () =>
  useMutationHook(updatePdfTemplate, [["readPdfTemplates"], ["readPdfTemplateDetail"]])

export const useDeletePdfTemplateMutation = () =>
  useMutationHook(deletePdfTemplate, [["readPdfTemplates"]])

export const useUpdatePdfTemplateLastUsedMutation = () =>
  useMutationHook(updatePdfTemplateLastUsed, [["readPdfTemplates"]])
